module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主播名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "remote": "",
      "remote-method": _vm.getAnchorList
    },
    on: {
      "change": _vm.handleAnchorChange
    },
    model: {
      value: (_vm.form.anchor_nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "anchor_nickname", $$v)
      },
      expression: "form.anchor_nickname"
    }
  }, _vm._l((_vm.anchorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.anchor_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "anchor_id", $$v)
      },
      expression: "form.anchor_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "remote": "",
      "remote-method": _vm.getDistributorList
    },
    on: {
      "change": _vm.handleDistibutorChange
    },
    model: {
      value: (_vm.form.distributor_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor_name", $$v)
      },
      expression: "form.distributor_name"
    }
  }, _vm._l((_vm.distributorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.inca_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "inca_id", $$v)
      },
      expression: "form.inca_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播标题"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "直播标题"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播简介"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "直播简介"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播间封面图片"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    model: {
      value: (_vm.form.cover_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "cover_image", $$v)
      },
      expression: "form.cover_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频类型",
      "prop": "source_video_type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "视频类型"
    },
    on: {
      "change": _vm.handleVideoTypeChange
    },
    model: {
      value: (_vm.form.source_video_type_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_video_type_text", $$v)
      },
      expression: "form.source_video_type_text"
    }
  }, _vm._l((_vm.sourceVideoTypeOption), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.source_video_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_video_type", $$v)
      },
      expression: "form.source_video_type"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频回放地址"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    model: {
      value: (_vm.form.source_video_url),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_video_url", $$v)
      },
      expression: "form.source_video_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否允许录播"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_record),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_record", $$v)
      },
      expression: "form.is_record"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-660323b1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-660323b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/live/add.vue
// module id = 2785
// module chunks = 0